import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { useReveal } from "../hooks/useReveal";
import { categories } from "../data/categories";

export const Catalogo = () => {
  const { t } = useI18n();
  const { ref, visible } = useReveal();

  return (
    <section
      id="catalogo"
      ref={ref}
      data-testid="catalog-section"
      className={`reveal ${visible ? "visible" : ""} bg-[#f8f9f8] py-24 md:py-32`}
    >
      <div className="pb-container">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-3xl">
            <div className="flex items-center gap-4 mb-6">
              <span className="block w-12 h-px bg-[#c9a84c]" />
              <span className="text-overline">{t.catalog.overline}</span>
            </div>
            <h2 className="font-heading font-bold text-[#1a3a2a] tracking-tight text-3xl md:text-5xl leading-[1.05] uppercase">
              {t.catalog.title}
            </h2>
          </div>
          <p className="text-[#4d6b5d] max-w-md text-base md:text-lg leading-relaxed">
            {t.catalog.sub}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-px bg-[#1a3a2a]/10">
          {categories.map((cat) => {
            const meta = t.catalog.categories[cat.slug] || { name: cat.slug, desc: "" };
            return (
              <article
                key={cat.slug}
                data-testid={`category-card-${cat.slug}`}
                className="group relative bg-white overflow-hidden transition-all duration-300 hover:bg-[#1a3a2a]"
              >
                <div className="aspect-square overflow-hidden bg-[#f0f1f0] relative">
                  <img
                    src={cat.image}
                    alt={meta.name}
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6 border-t border-[#1a3a2a]/10 group-hover:border-[#c9a84c]/40 transition-colors">
                  <h3 className="font-heading font-bold text-base md:text-lg uppercase tracking-tight text-[#1a3a2a] group-hover:text-white transition-colors">
                    {meta.name}
                  </h3>
                  <p className="mt-2 text-sm text-[#4d6b5d] group-hover:text-white/70 leading-relaxed transition-colors">
                    {meta.desc}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
